import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-new-sms',
  templateUrl: './sms-new-sms.component.html',
  styleUrls: ['./sms-new-sms.component.scss']
})
export class SmsNewSmsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
